/* AURA Performance Engine 4.0 — Core Framework */
(() => {
  document.documentElement.classList.add('aura-performance-ready');
  document.body?.classList.add('aura-perf4');

  const log = (name, value, meta = {}) => {
    window.AuraPerformance = window.AuraPerformance || { metrics: [] };
    window.AuraPerformance.metrics.push({
      name,
      value,
      meta,
      time: Math.round(performance.now())
    });
    document.dispatchEvent(new CustomEvent('aura:performance:metric', { detail: { name, value, meta } }));
  };

  const initLazySections = () => {
    const sections = document.querySelectorAll('[data-aura-lazy-section], section');
    if (!('IntersectionObserver' in window)) {
      sections.forEach(s => s.classList.add('is-aura-ready'));
      return;
    }

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.classList.add('is-aura-ready');
        el.dispatchEvent(new CustomEvent('aura:section:visible', { bubbles: true }));
        window.AuraRegistry?.initAll(el);
        io.unobserve(el);
      });
    }, { rootMargin: '320px 0px', threshold: .01 });

    sections.forEach(section => {
      if (!section.hasAttribute('data-aura-lazy-section')) section.setAttribute('data-aura-lazy-section', '');
      io.observe(section);
    });
  };

  const initDeferredScripts = () => {
    document.querySelectorAll('script[type="aura/defer"][data-src]').forEach(script => {
      const load = () => {
        const s = document.createElement('script');
        s.src = script.dataset.src;
        s.defer = true;
        if (script.dataset.module === 'true') s.type = 'module';
        document.head.appendChild(s);
      };
      window.AuraIdle?.add(`script:${script.dataset.src}`, load);
    });
  };

  const initReveal = () => {
    const items = document.querySelectorAll('[data-aura-defer]');
    if (!('IntersectionObserver' in window)) {
      items.forEach(el => el.classList.add('is-aura-ready'));
      return;
    }

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-aura-ready');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '180px 0px', threshold: .06 });

    items.forEach(el => io.observe(el));
  };

  const monitor = () => {
    const enabled = new URLSearchParams(location.search).get('aura_perf') === '1' || localStorage.getItem('aura_perf_debug') === 'true';
    if (!enabled) return;
    document.body.setAttribute('data-aura-perf-debug', 'true');

    const panel = document.createElement('div');
    panel.className = 'aura-perf4__monitor';
    panel.innerHTML = '<h3>AURA Performance</h3><div data-aura-perf-rows></div>';

    const toggle = document.createElement('button');
    toggle.className = 'aura-perf4__toggle';
    toggle.textContent = 'PF';

    document.body.appendChild(panel);
    document.body.appendChild(toggle);

    const render = () => {
      const rows = panel.querySelector('[data-aura-perf-rows]');
      const nav = performance.getEntriesByType('navigation')[0];
      const metrics = window.AuraPerformance?.metrics || [];
      rows.innerHTML = `
        <div class="aura-perf4__monitor-row"><span>DOM Ready</span><small>${Math.round(nav?.domContentLoadedEventEnd || 0)}ms</small></div>
        <div class="aura-perf4__monitor-row"><span>Load</span><small>${Math.round(nav?.loadEventEnd || 0)}ms</small></div>
        <div class="aura-perf4__monitor-row"><span>Registry</span><small>${window.AuraRegistry?.getMetrics?.().length || 0} components</small></div>
        ${metrics.slice(-8).map(m => `<div class="aura-perf4__monitor-row"><span>${m.name}</span><small>${m.value}</small></div>`).join('')}
      `;
    };

    toggle.addEventListener('click', () => {
      panel.classList.toggle('is-visible');
      render();
    });

    setInterval(render, 2500);
  };

  const init = () => {
    const start = performance.now();
    initLazySections();
    initDeferredScripts();
    initReveal();
    window.AuraRegistry?.initAll(document);
    monitor();
    log('perf-core-init', `${Math.round(performance.now() - start)}ms`);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', e => {
    window.AuraRegistry?.initAll(e.target);
    initReveal();
  });
})();
